import * as React from "react";
const IconDuration = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.7363 13.4924C20.7363 18.1869 16.9307 21.9924 12.2363 21.9924C7.54191 21.9924 3.73633 18.1869 3.73633 13.4924C3.73633 8.79801 7.54191 4.99243 12.2363 4.99243C16.9307 4.99243 20.7363 8.79801 20.7363 13.4924Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
    />
    <path
      d="M15.2363 2.4065C14.2827 2.13677 13.2764 1.99243 12.2363 1.99243C11.1963 1.99243 10.19 2.13677 9.23633 2.4065"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M13.7363 13.9924C13.7363 14.8209 13.0648 15.4924 12.2363 15.4924C11.4079 15.4924 10.7363 14.8209 10.7363 13.9924C10.7363 13.164 11.4079 12.4924 12.2363 12.4924C13.0648 12.4924 13.7363 13.164 13.7363 13.9924Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
    />
    <path
      d="M12.2363 11.9924V8.99243"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconDuration;
